module.exports = __webpack_public_path__ + "static/img/Alterity1.6315542.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/misc_3d/alterity/Alterity1.jpg
// module id = SDfe
// module chunks = 1